import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import { TableRow, TableCell } from '@material-ui/core';
import '../shared/Table.css';

const TotalNumberOfBreaksRow = ({ numberOfBreaksPerDay }) => {
  return (
    <TableRow className='schedulingRow'>
      <TableCell className='schedulingRowCell'>
        Total Number of Breaks Required
      </TableCell>
      { numberOfBreaksPerDay.map((dateObject, index) => {
        const { amount, date } = dateObject;
        const isToday = moment(date).isSame(moment(), 'day');
        const classes = classnames({
          'flex-rows': true,
          'schedulingRowCell': true,
          'scheduleRowTimeCell': true,
          'shift-cell-today': isToday
        });

        return (
          <TableCell key={index} className={classes} style={{ textAlign: 'center' }}>
            { amount }
          </TableCell>
        );
      })}
    </TableRow>
  );
};

TotalNumberOfBreaksRow.propTypes = {
  breakMinutesPerDay: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string, // YYYY-MM-DD format
    amount: PropTypes.number
  }))
};

export default TotalNumberOfBreaksRow;
